import axios from 'axios';
import { getConfig } from '@/config';

export const coupangReviewFailuresInstance = axios.create({
  baseURL: getConfig().internalApiUrl,
  timeout: 15000,
});

coupangReviewFailuresInstance.interceptors.request.use((requestConfig) => {
  requestConfig.headers.set('X-API-Key', getConfig().apiKey);
  return requestConfig;
});
